/* eslint-disable @typescript-eslint/no-explicit-any */


import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';
import { FormErrorMessage, errorMessages } from '@app/shared/models/errorsMessage';

@Component({
    selector: 'app-errors-messages',
    templateUrl: './shared-errors-messages.component.html',
    styleUrls: ['./shared-errors-messages.component.scss'],
    imports: [],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedErrorsMessagesComponent implements OnChanges {
  @Input() control!: FormControl | AbstractControl | null;
  errorText!: string | undefined;

  private readonly INVALID_STATUS = 'INVALID';
  private readonly destroyRef = inject(DestroyRef);
  
  constructor(private readonly ref: ChangeDetectorRef) {}

  ngOnChanges(ev: SimpleChanges) {
    if (ev['control'].currentValue) {
      this.setErrors();
    }
  }

  setErrors() {
    if (this.control) {
      if (this.control.status === this.INVALID_STATUS) {
        this.showError(this.control);
      }

      this.control.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(status => {
        if (status === this.INVALID_STATUS && this.control?.errors) {
          this.showError(this.control);
        } else {
          this.removeError();
        }
      });
    }
  }

  private showError(control: FormControl | AbstractControl) {
    this.errorText = this.setValidationMsg(control.errors);
    this.ref.markForCheck();
  }

  private removeError(): void {
    this.errorText = '';
    this.ref.markForCheck();
  }

  setValidationMsg(valErrors: ValidationErrors | null): string | undefined {
    let errorMsg: string | undefined = undefined;
    if (valErrors) {
      const errorKey = Object.keys(valErrors)[0] as keyof FormErrorMessage;
      const errorValue = valErrors[errorKey];
      const errorMessageItem = errorMessages[errorKey];

      if (errorMessageItem) {
        const [errorParam1, errorParam2] = errorMessageItem.params(errorValue);

        errorMsg = errorMessageItem.label;
        if (errorParam1 !== null) {
          errorMsg = errorMsg.replace('$1', errorParam1);
        }
        if (errorParam2 !== null) {
          errorMsg = errorMsg.replace('$2', errorParam2);
        }
      }
    }
    return errorMsg;
  }
}
